export const tableFilterButtonSx = {
  minHeight: 42,
  px: 1.5,
  py: 0.5,
  borderRadius: "999px",
  border: "1px solid",
  borderColor: "grey.300",
  backgroundColor: "common.white",
  color: "text.primary",
  whiteSpace: "nowrap",
  textTransform: "none",
  "&:hover": {
    borderColor: "grey.400",
    backgroundColor: "grey.50",
  },
};

export const tableDateFilterSx = {
  minHeight: 42,
  px: 1,
  borderRadius: "999px",
  border: "1px solid",
  borderColor: "grey.300",
  backgroundColor: "common.white",
  color: "text.primary",
  whiteSpace: "nowrap",
  "&:hover": {
    borderColor: "grey.400",
    backgroundColor: "grey.50",
  },
  "& .MuiButton-root": {
    minWidth: 0,
    minHeight: 40,
    border: 0,
    background: "transparent",
    color: "text.primary",
    textTransform: "none",
    "&:hover, &:focus": {
      border: 0,
      background: "none",
      backgroundColor: "grey.50",
      boxShadow: "none",
    },
  },
  "& .MuiIconButton-root": {
    p: 0.5,
  },
};
